import React from 'react';

import { useMediaQuery, useTheme } from '@mui/material';

import { Main, SideBar } from './index.styles';

interface PageContentProps {
  sideBar?: React.ReactElement,
  sideBarOpen?: boolean,
  sideBarWidth?: number,
  sideBarFullPage?: boolean,
  children: React.ReactElement | React.ReactElement[],
}

const PageContent = ({
  sideBar,
  sideBarOpen = false,
  sideBarWidth = 400,
  children,
  sideBarFullPage = true,
}: PageContentProps) => {
  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Main $open={sideBarOpen} $width={sideBarWidth} $isLg={isLg}>
      {children}
      {sideBar && (
        <SideBar
          $width={sideBarWidth}
          variant={isLg ? 'persistent' : 'temporary'}
          anchor="right"
          open={sideBarOpen}
          $isLg={isLg}
          $fullPage={sideBarFullPage}
        >
          {sideBar}
        </SideBar>
      )}
    </Main>
  );
};
export default PageContent;
